/* eslint-disable no-useless-concat */
import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { Paper, Icon } from "@mui/material";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { DELETE_TAX, TAX_ID } from "./Graphql";
import { KeyValuePair } from "../HOC/CustomComponents/KeyValuePair";
import { Globals } from "../HOC/Classes/Globals";
import Grid from "@mui/material/Unstable_Grid2";
import TitleAppBar from "../../Layout/TitleAppBar";
import { pushUrl } from "../HOC/CustomFunctions/pushUrl";
import LongMenu from "../../Layout/MenuAppBar";
import NotFound from "../../Error/NotFound";
import MutationWithDialog from "../HOC/CustomComponents/MutationWithDialog";

import { StyledLoading, classesLoad } from "../../GlobalStyles/LoadingStyle";
import { RootStyleView, classesView } from "../../GlobalStyles/ViewStyle";
const TaxView = (props) => {
  const id = props.match.params.id?.trim();
  const { t } = useTranslation();
  const user = Globals.user;
  const [openDelete, setOpenDelete] = useState(false);

  const openDeleteDialog = (type) => {
    setOpenDelete(true);
  };
  const { loading, data } = useQuery(
    gql`
      ${TAX_ID.query}
    `,
    {
      fetchPolicy: "network-only",
      variables: { id: parseInt(id) },
    }
  );
  const taxData = data?.tax;

  const icons = [
    {
      id: "edit",
      action: () => pushUrl(props, `/admin/tax/${id}/edit`),
      permission: user?.hasPermission("freight.tax.update"),
    },
    {
      id: "delete",
      action: openDeleteDialog,
      permission: Boolean(
        user?.hasPermission("freight.tax.delete") && taxData?.deletable
      ),
    },
  ];
  return loading ? (
    <StyledLoading
      container
      item
      justifyContent="center"
      className={classesLoad.main}
    >
      <FullScreenLoading height={"100%"} />
    </StyledLoading>
  ) : !taxData ? (
    <NotFound />
  ) : (
    <>
      {openDelete && (
        <MutationWithDialog
          mutaion={DELETE_TAX.query}
          setOpenDelete={setOpenDelete}
          openDelete={openDelete}
          dialogTitle={t("deleteRecord")}
          dialogContent={t("deleteRecordMessage")}
          mutaionProps={{
            variables: { id: parseInt(id) },
          }}
          onCompleted={() => pushUrl(props, `/admin/tax`)}
          onCompleteMessage={t("successfullyDeletedRecord")}
        />
      )}
      <TitleAppBar path={props.match.path}>
        <LongMenu icons={icons} />
      </TitleAppBar>

      <RootStyleView spacing={2} p={2} justifyContent="center">
        <Paper container className={classesView.paper} component={Grid}>
          <KeyValuePair title={t("code")} value={taxData?.code} />
          <KeyValuePair title={t("name")} value={taxData?.name} />
          <KeyValuePair title={t("rate")} value={taxData?.rate} />
          <KeyValuePair
            title={t("glAccount")}
            value={taxData?.glAccount?.name}
          />
          <KeyValuePair title={t("type")} value={taxData?.type?.name} />
          <KeyValuePair
            title={t("air")}
            value={
              taxData?.air ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />
          <KeyValuePair
            title={t("land")}
            value={
              taxData?.land ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />

          <KeyValuePair
            title={t("ocean")}
            value={
              taxData?.ocean ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />
          <KeyValuePair
            title={t("active")}
            value={
              taxData?.active ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("import")}
            value={
              taxData?.import ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("export")}
            value={
              taxData?.export ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
        </Paper>
      </RootStyleView>
    </>
  );
};

export default TaxView;
